import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { JwtInterceptor } from './_Interceptor/jwt.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { spinnerInterceptor } from './_Interceptor/spinner.interceptor';
import { provideToastr } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Ability, PureAbility } from '@casl/ability';
import { errorToastInterceptor } from './_Interceptor/error-toast-.interceptor';
import { safeUrlInterceptor } from './_Interceptor/safe-url.interceptor';
import { authSessionInterceptor } from './_Interceptor/auth-session.interceptor';



export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
export const provideTranslation = () => ({
  defaultLanguage: 'en',
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
});



export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([
      safeUrlInterceptor,
      JwtInterceptor,
      authSessionInterceptor,
      errorToastInterceptor,
      spinnerInterceptor
    ])),
    importProvidersFrom(NgxSpinnerModule.forRoot({ type: 'line-scale-pulse-out ' }), BrowserAnimationsModule),
    provideToastr(),
    importProvidersFrom([
      HttpClientModule,
      TranslateModule.forRoot(provideTranslation())
    ]),
    { provide: Ability, useValue: new Ability() },
    { provide: PureAbility, useExisting: Ability }
  ]
};
